/* Round 46: keep pickup messaging aligned with the cart's actual remaining items.
   No changes to prices, discounts, shipping rates or checkout enforcement. */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    root.InStockyDelivery = api;
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', api.init);
    else api.init();
    root.document.addEventListener('shopify:section:load', api.init);
  }
})(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';
  var config = null;
  function readConfig() {
    if (!root) return { products: {}, strings: {} };
    var node = root.document.getElementById('InStockyCartDeliveryData');
    if (!node) return { products: {}, strings: {} };
    if (config && config.node === node) return config.data;
    try { config = { node: node, data: JSON.parse(node.textContent) }; return config.data; }
    catch (error) { return { products: {}, strings: {} }; }
  }
  function productMode(id) {
    var products = readConfig().products || {};
    return Object.prototype.hasOwnProperty.call(products, String(id)) ? products[String(id)] : 'unknown';
  }
  function classify(items, products) {
    var pickup = 0, other = 0, unknown = 0;
    (items || []).forEach(function (item) {
      if (!(Number(item.quantity) > 0)) return;
      var mode = products[String(item.product_id)];
      if (mode === 'pickup') pickup++;
      else if (mode === 'normal' || mode === 'heavy') other++;
      else unknown++;
    });
    if (unknown) return 'unknown'; // Do not promise shipping for data we have not read.
    return pickup ? (other ? 'mixed' : 'pickup') : 'normal';
  }
  function setText(selector, value) {
    if (!root || typeof value !== 'string') return;
    root.document.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
  }
  function updateCart(cart) {
    if (!root || !cart) return;
    var data = readConfig(), strings = data.strings || {};
    var mode = classify(cart.items, data.products || {});
    var special = mode !== 'normal';
    var notice = root.document.querySelector('[data-instocky-cart-delivery-notice]');
    if (notice) notice.hidden = !special;
    var lead = mode === 'normal' ? strings.normalLead : mode === 'unknown' ? strings.unknownLead : strings.pickupLead;
    var benefit = strings[mode + 'Benefit'];
    setText('[data-instocky-cart-lead]', lead);
    setText('[data-instocky-cart-delivery-copy]', strings[mode + 'Notice']);
    setText('[data-instocky-cart-delivery-benefit]', benefit);
    setText('[data-instocky-header-delivery]', benefit);
    var included = typeof cart.taxes_included === 'boolean' ? cart.taxes_included : data.taxesIncluded;
    var taxKey = mode + 'Taxes' + (included && mode !== 'unknown' ? 'Included' : '');
    setText('[data-instocky-cart-tax-delivery]', strings[taxKey]);
    return mode;
  }
  function init() {
    if (!root || !root.document.getElementById('InStockyCartDeliveryData')) return;
    var node = root.document.querySelector('script[id^="CartJson-"]');
    if (!node) return;
    try { updateCart(JSON.parse(node.textContent)); } catch (error) { /* Keep server-rendered copy. */ }
  }
  return { init: init, productMode: productMode, classify: classify, updateCart: updateCart };
});
